import apiClient from '@/api/axiosClient';

// RowId er bigint i SQL Server (opptil 2^63-1), men JavaScript number
// støtter kun safe integers opptil 2^53-1. Backend kan derfor serialisere
// store tall som strings, så vi må støtte begge typer.
export type RowId = number | string;

export interface SoftDeleteRequest {
  databaseObjectId: number;
  rowIds: RowId[];
}

export interface RestoreRequest {
  databaseObjectId: number;
  rowIds: RowId[];
}

export interface SoftDeleteResponse {
  deletedRows: number;
}

export interface RestoreResponse {
  restoredRows: number;
}

/**
 * Soft-delete rader (setter ICS_SoftDeleted = true)
 * Bruker dedikert endepunkt som omgår systemkolonne-beskyttelsen
 */
export async function softDeleteRows (
  request: SoftDeleteRequest,
  signal?: AbortSignal
): Promise<SoftDeleteResponse> {
  const response = await apiClient.delete<SoftDeleteResponse>('v2/query/rows', {
    data: request,
    signal
  });
  return response.data;
}

/**
 * Gjenopprett rader (setter ICS_SoftDeleted = false)
 * Bruker dedikert endepunkt som omgår systemkolonne-beskyttelsen
 */
export async function restoreRows (
  request: RestoreRequest,
  signal?: AbortSignal
): Promise<RestoreResponse> {
  const response = await apiClient.put<RestoreResponse>('v2/query/rows/restore', request, {
    signal
  });
  return response.data;
}

